import React from 'react';
import Slide from 'react-reveal';
import PropTypes from 'prop-types';

const DURATION_TIME = 1300;

const Application = ({ data }) => {
  if (!data) return null;

  const { mapCountriesAndCities, otherMaps, stats, moneyConverter, passport } = data;

  const mapCountriesAndCitiesView = mapCountriesAndCities.map((map) => {
    const { title, description } = map;
    return (
      <div key={title}>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    );
  });

  const otherMapsView = otherMaps.map((map) => {
    const { title, description } = map;
    return (
      <div key={title}>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    );
  });

  const statsView = stats.data.map((stat) => {
    const { description } = stat;
    return (
      <li key={description}>
        <p>{description}</p>
      </li>
    );
  });

  const moneyConverterView = () => {
    const { title, description1, description2, description3, description4 } = moneyConverter;
    return (
      <div key={title}>
        <h1>{title}</h1>
        <p>{description1}</p>
        <p>{description2}</p>
        <p>{description3}</p>
        <p>{description4}</p>
      </div>
    );
  };

  const passportView = () => {
    const { title, description1, description2, description3 } = passport;
    return (
      <div key={title}>
        <h1>{title}</h1>
        <p>{description1}</p>
        <p>{description2}</p>
        <p>{description3}</p>
      </div>
    );
  };

  const language = 'en';
  return (
    <section id="application">
      <Slide left duration={DURATION_TIME}>
        <div className="row map-countries-cities">
          <div className="nine columns main-col-left">
            <div className="row item">
              <div className="twelve columns">{mapCountriesAndCitiesView}</div>
            </div>
          </div>
          <div className="three columns img-col">
            <img
              src={`images/application/${language}/maps_countries_cities.webp`}
              alt="Map countries and cities"
            />
          </div>
        </div>
      </Slide>

      <Slide right duration={DURATION_TIME}>
        <div className="row other-maps">
          <div className="three columns img-col">
            <img src={`images/application/${language}/airports.webp`} alt="Premiums map" />
          </div>
          <div className="nine columns main-col-right">{otherMapsView}</div>
        </div>
      </Slide>

      <Slide left duration={DURATION_TIME}>
        <div className="row stats">
          <div className="nine columns main-col-left">
            <h1>{stats.title}</h1>
            <ul className="stats-list">{statsView}</ul>
          </div>
          <div className="three columns img-col">
            <img src={`images/application/${language}/stats.webp`} alt="Statistics" />
          </div>
        </div>
      </Slide>

      <Slide right duration={DURATION_TIME}>
        <div className="row converter">
          <div className="three columns img-col">
            <img
              src={`images/application/${language}/money_converter.webp`}
              alt="Money converter"
            />
          </div>
          <div className="nine columns main-col-right">{moneyConverterView()}</div>
        </div>
      </Slide>

      <Slide left duration={DURATION_TIME}>
        <div className="row passports">
          <div className="nine columns main-col-left">{passportView()}</div>
          <div className="three columns img-col">
            <img src={`images/application/${language}/passports.webp`} alt="Passports and visas" />
          </div>
        </div>
      </Slide>
    </section>
  );
};

Application.propTypes = {
  data: PropTypes.shape({
    mapCountriesAndCities: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
      }),
    ),
    otherMaps: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
      }),
    ),
    stats: PropTypes.shape({
      title: PropTypes.string,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
        }),
      ),
    }),
    moneyConverter: PropTypes.shape({
      title: PropTypes.string,
      description1: PropTypes.string,
      description2: PropTypes.string,
      description3: PropTypes.string,
      description4: PropTypes.string,
    }),
    passport: PropTypes.shape({
      title: PropTypes.string,
      description1: PropTypes.string,
      description2: PropTypes.string,
      description3: PropTypes.string,
    }),
  }).isRequired,
};

export default Application;
